import { render, staticRenderFns } from "./MatchProtocol.vue?vue&type=template&id=0ab70b58&scoped=true&"
var script = {}
import style0 from "./MatchProtocol.vue?vue&type=style&index=0&id=0ab70b58&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab70b58",
  null
  
)

export default component.exports